import React from 'react'
import clsx from 'clsx'

// The page's one content width: 1200px with --gutter either side (20px on a
// phone, 24px from 960px up). `width="read"` narrows it to 640px, the
// 60-72 character measure the design direction asks for in running text.
export const Container = ({ width, className, children, ...rest }) => (
  <div className={clsx('gwmc-container', width === 'read' && 'gwmc-container--read', className)} {...rest}>
    {children}
  </div>
)
